import React from 'react';
import ReactDOM from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { JWTAuthProvider } from 'contexts/JWTAuth';
import App from './App';
import 'nprogress/nprogress.css';
import 'pure-react-carousel/dist/react-carousel.es.css';

const root = ReactDOM.createRoot(document.getElementById(`root`) as HTMLElement);
root.render(
    <React.StrictMode>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <JWTAuthProvider>
                <App />
            </JWTAuthProvider>
        </LocalizationProvider>
    </React.StrictMode>
);
